"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 *  * Typed error for subscription service
 * @param {string} message the validation message
 */
class InvalidSubscriptionProductIdError extends client_library_1.ExtendableError {
    constructor() {
        super('InvalidSubscriptionProductId');
    }
}
exports.default = InvalidSubscriptionProductIdError;
//# sourceMappingURL=InvalidSubscriptionProductIdError.js.map